import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { zIndex } from '../../../../../play-core/styles/z-index';
import { TransparentButton } from '../../../components/ClickableComponents/Button';
import { secondLevelNaviHeight } from '../../../components/Header/SecondLevelNavigation/SecondLevelNavigation.styles';
import { PlayContainer, ContentContainer } from '../../../components/PlayContainer/PlayContainer';
export const StyledChannelSelector = styled.div.withConfig({
  displayName: "ChannelSelectorstyles__StyledChannelSelector",
  componentId: "sc-1bvqdmt-0"
})(["position:sticky;z-index:", ";top:", "px;"], zIndex.stickyBar, secondLevelNaviHeight);
export const ChannelIconsContainer = styled(PlayContainer).withConfig({
  displayName: "ChannelSelectorstyles__ChannelIconsContainer",
  componentId: "sc-1bvqdmt-1"
})(["background-color:", ";margin-bottom:16px;padding-top:6px;padding-bottom:6px;", "{overflow:hidden;}"], Colors.DARK_202020, ContentContainer);
export const List = styled.ul.withConfig({
  displayName: "ChannelSelectorstyles__List",
  componentId: "sc-1bvqdmt-2"
})(["height:60px;display:grid;grid-column-gap:8px;grid-auto-flow:column;align-items:center;", "{align-content:stretch;}", "{height:48px;}"], Viewports.for('largeUp'), Viewports.for('small'));
export const ListItem = styled.li.withConfig({
  displayName: "ChannelSelectorstyles__ListItem",
  componentId: "sc-1bvqdmt-3"
})(["width:100%;"]);
export const PreviousChannelSelection = styled(PlayContainer).withConfig({
  displayName: "ChannelSelectorstyles__PreviousChannelSelection",
  componentId: "sc-1bvqdmt-4"
})(["align-items:center;height:36px;margin-bottom:24px;", ";color:", ";", "{margin-bottom:16px;", ";}"], Fonts.regular(18), Colors.GREY_d2d2d2, Viewports.for('small'), Fonts.regular(16));
export const PreviousSelectedChannelLink = styled(TransparentButton).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "ChannelSelectorstyles__PreviousSelectedChannelLink",
  componentId: "sc-1bvqdmt-5"
})(["display:inline;padding-left:8px;padding-right:8px;"]);